import React, { useState } from 'react';
import { Divider, LoadingSpinner, Stack, Text } from '@adc/parallax-component-library';
import { fromUnixTime, isAfter } from 'date-fns';
import { ApiStatus } from 'Enums';
import { useApiError, useLibreDataShare } from 'Hooks';
import { Button, Form, Link, Main, RichText, ScrollContainer, TitleActionBar, } from 'Components/utility';
import { notifyApp } from 'Utilities/appCommunicator';
import { formatDataShareCode } from 'Utilities/dataHelpers';
import { formatTimestamp } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const LibreDataShareConnection = ({ data: { dataShareConnection } }) => {
    const [footerLoading, setFooterLoading] = useState(false);
    const { monthDate, time } = formatTimestamp(dataShareConnection?.expiresAt || 0);
    const { showStopSharingModal, stopDataShare } = useLibreDataShare();
    const { showApiErrorModal } = useApiError();
    const isCodeExpired = () => {
        return (dataShareConnection?.expiresAt &&
            isAfter(new Date(), fromUnixTime(dataShareConnection.expiresAt)));
    };
    const handleStopSharing = () => {
        if (isCodeExpired()) {
            mediator.publish('router:navigate', '/connections');
            return;
        }
        showStopSharingModal(async () => {
            try {
                setFooterLoading(true);
                await stopDataShare();
                mediator.publish('router:navigate', '/connections');
            }
            catch (err) {
                const error = err;
                if (error.status === ApiStatus.NOT_FOUND) {
                    mediator.publish('router:navigate', '/connections');
                    return;
                }
                showApiErrorModal();
            }
            finally {
                setFooterLoading(false);
            }
        }, () => {
            if (isCodeExpired()) {
                mediator.publish('router:navigate', '/connections');
            }
        });
    };
    const handleShareCode = async () => {
        if (isCodeExpired() || !dataShareConnection?.code) {
            mediator.publish('router:navigate', '/connections');
            return;
        }
        notifyApp('adc-webview:data-share-code', {
            message: i18n.t('Connections.content.libreDataShareCard.links.temporaryCode.label', {
                code: formatDataShareCode(dataShareConnection?.code),
            }),
        });
    };
    if (!dataShareConnection) {
        mediator.publish('router:navigate', '/connections');
        return null;
    }
    return (React.createElement(Main, null,
        React.createElement(TitleActionBar, { testID: "SharingCodeScreen.title", title: i18n.t('Connections.content.libreDataShareCard.primaryText') }),
        React.createElement(ScrollContainer, { marginTop: 0 },
            React.createElement(Form, null,
                React.createElement(Stack, { padding: "$4", backgroundColor: "$surface.container", border: "$1.5", shadow: "$1" },
                    React.createElement(RichText, { testID: "SharingCodeScreen.bodyText", fontToken: "$bodyBase.default", color: "$text.100", text: i18n.t('Connections.content.sharingCodeScreen.bodyText') }),
                    React.createElement(Stack, { alignItems: "center", marginTop: "$7" },
                        React.createElement(Text, { testID: "SharingCodeScreen.code", fontSize: "$dataSmall.medium", fontWeight: "$dataSmall.medium", color: "$text.100" }, formatDataShareCode(dataShareConnection.code)),
                        React.createElement(Text, { testID: "SharingCodeScreen.expiresAt", fontSize: "$bodySmall.default", fontWeight: "$bodySmall.default", color: "$text.100", marginTop: "$3" }, i18n.t('Connections.content.sharingCodeScreen.primaryText', {
                            time,
                            monthDate,
                        }))),
                    React.createElement(Button, { testID: "SharingCodeScreen.shareCode-btn", padding: "$4", flexGrow: 1, onPress: handleShareCode, variant: "primary", "aria-label": i18n.t('Connections.content.sharingCodeScreen.links.shareCodeBtn.label'), label: i18n.t('Connections.content.sharingCodeScreen.links.shareCodeBtn.label'), marginTop: "$5" }),
                    React.createElement(Divider, { marginVertical: "$5", marginTop: "$3" }),
                    footerLoading ? (React.createElement(Stack, { width: "100%", display: "flex", alignItems: "center" },
                        React.createElement(LoadingSpinner, null))) : (React.createElement(Link, { testID: "SharingCodeScreen.stopSharing-btn", onPress: handleStopSharing, textColor: "$support.danger.default" }, i18n.t('Connections.content.sharingCodeScreen.links.stopSharingBtn.label'))))))));
};
export default LibreDataShareConnection;
